module.exports = __webpack_public_path__ + "img/arrow-white-down.8c2409b0.svg";